module.exports = __webpack_public_path__ + "static/media/GirlStickers.edeadf8f.jpg";